/**
 * K.H. Mosaic - Cinematic Hero Slider Logic
 */

class KHCinematicHero {
    constructor(section) {
        this.section = section;
        this.slider = section.querySelector('.kh-hero-cinematic__slider');
        this.slides = Array.from(section.querySelectorAll('.kh-hero-cinematic__slide'));
        this.dots = Array.from(section.querySelectorAll('.kh-hero-cinematic__dot'));
        this.nextBtn = section.querySelector('.kh-hero-cinematic__arrow--next');
        this.prevBtn = section.querySelector('.kh-hero-cinematic__arrow--prev');

        this.autoplay = section.dataset.autoplay === 'true';
        this.interval = parseInt(section.dataset.speed) || 5000;
        this.currentIndex = 0;
        this.timer = null;

        this.init();
    }

    init() {
        if (this.slides.length <= 1) return;

        this.bindEvents();
        this.startAutoplay();
        this.updateSlider();
    }

    bindEvents() {
        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', () => {
                this.nextSlide();
                this.resetAutoplay();
            });
        }

        if (this.prevBtn) {
            this.prevBtn.addEventListener('click', () => {
                this.prevSlide();
                this.resetAutoplay();
            });
        }

        this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                this.goToSlide(index);
                this.resetAutoplay();
            });
        });

        // Pause on hover (Desktop only)
        if (window.matchMedia('(min-width: 990px)').matches) {
            this.section.addEventListener('mouseenter', () => this.stopAutoplay());
            this.section.addEventListener('mouseleave', () => this.startAutoplay());
        }

        // Touch support
        let startX = 0;
        this.slider.addEventListener('touchstart', (e) => startX = e.touches[0].clientX, { passive: true });
        this.slider.addEventListener('touchend', (e) => {
            let endX = e.changedTouches[0].clientX;
            if (startX - endX > 50) this.nextSlide();
            if (endX - startX > 50) this.prevSlide();
            this.resetAutoplay();
        }, { passive: true });
    }

    goToSlide(index) {
        this.currentIndex = index;
        this.updateSlider();
    }

    nextSlide() {
        this.currentIndex = (this.currentIndex + 1) % this.slides.length;
        this.updateSlider();
    }

    prevSlide() {
        this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
        this.updateSlider();
    }

    updateSlider() {
        this.slides.forEach((slide, i) => {
            slide.classList.toggle('kh-hero-cinematic__slide--active', i === this.currentIndex);
        });

        this.dots.forEach((dot, i) => {
            dot.classList.toggle('kh-hero-cinematic__dot--active', i === this.currentIndex);
        });
    }

    startAutoplay() {
        if (!this.autoplay) return;
        this.stopAutoplay();
        this.timer = setInterval(() => this.nextSlide(), this.interval);
    }

    stopAutoplay() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    resetAutoplay() {
        this.startAutoplay();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const cinematicHeroes = document.querySelectorAll('.kh-hero-cinematic-section');
    cinematicHeroes.forEach(hero => new KHCinematicHero(hero));
});

// Re-init for Shopify Theme Editor
if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
        if (event.target.classList.contains('kh-hero-cinematic-section')) {
            new KHCinematicHero(event.target);
        }
    });
}
